<mat-form-field
  class="form-chip-list"
  [class.light-form-field]="lightFormField$ | async"
  data-cy="certificate-input">
  <mat-label class="d-flex align-center gap-4">
    <mat-icon
      mat-suffix
      *ngIf="withIcon$ | async"
      svgIcon="certificate"
      class="size-20"></mat-icon
    >{{ ("certificates" | i18n) || "Qualifikation" | titlecase
    }}{{ (required$ | async) ? "  *" : "" }}</mat-label
  >
  <mat-chip-list
    #certificateList
    [disabled]="disabled$ | async">
    <mat-chip
      *ngFor="
        let certificate of selectedCertificates$ | async;
        trackBy: trackByCertificateId
      "
      [attr.data-cy]="'selected-certificate-' + certificate._id"
      [attr.title]="certificate.name"
      class="certificate-chip">
      <span>{{ certificate.name }}</span>
      <mat-icon
        matChipRemove
        *ngIf="!(disabled$ | async) && !(addOnly$ | async)"
        data-cy="remove-certificate"
        svgIcon="close-circle"
        (click)="removeCertificate(certificate._id)">
      </mat-icon>
    </mat-chip>
    <input
      ngModel
      #certificateInput="ngModel"
      name="certificateInput"
      [disabled]="!!(disabled$ | async)"
      [required]="!!(required$ | async)"
      [matAutocomplete]="autoCertificates"
      [matChipInputFor]="certificateList"
      data-cy="certificate-text-input" />
  </mat-chip-list>
  <mat-autocomplete
    #autoCertificates="matAutocomplete"
    (optionSelected)="selectedCertificate($event)">
    <ng-container
      *ngIf="
        !(noCertificateGroups$ | async) &&
        (customerCertificateGroups$ | async)?.length
      ">
      <mat-option
        *ngFor="
          let certificateGroup of customerCertificateGroups$ | async;
          trackBy: trackByCertificateGroupId
        "
        [attr.data-cy]="'certificate-option-' + certificateGroup.id"
        [value]="certificateGroup">
        {{ certificateGroup.displayName }}
      </mat-option>
      <mat-divider></mat-divider
    ></ng-container>
    <mat-option
      *ngFor="
        let certificate of filteredCertificates$ | async;
        trackBy: trackByCertificateId
      "
      [attr.data-cy]="'certificate-option-' + certificate._id"
      [value]="certificate">
      {{ certificate.name }}
    </mat-option>
  </mat-autocomplete>
  <mat-hint
    *ngIf="showHint$ | async"
    align="end">
    <ng-content select="[slot=hint]"></ng-content>
  </mat-hint>
</mat-form-field>
